import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  GridProps,
  FormHelperText,
} from '@mui/material';
import { FORM_STYLES } from '../../../constants';
import CustomDropdownIcon from '../../CustomDropdownIcon';
import TooltipWithClickAway from '../../terminalPicker/TooltipWithClickAway';

interface SelectOption {
  value: string;
  label: string;
}

interface FormikSelectProps {
  name: string;
  label: string;
  value: string;
  onChange: (event: any) => void;
  onBlur: (event: any) => void;
  options: SelectOption[];
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  gridProps?: GridProps;
  tooltip?: {
    text: string;
    key: string;
  };
}

const FormikSelect: React.FC<FormikSelectProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  options,
  error,
  placeholder = 'Please select option',
  disabled = false,
  required = false,
  gridProps = { xs: 12, md: 4 },
  tooltip,
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl fullWidth size={FORM_STYLES.FIELD_SIZE} error={!!error}>
        <InputLabel 
          shrink 
          style={FORM_STYLES.LABEL}
          id={`${name}Label`}
          htmlFor={name}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            {label} {required && <sup>*</sup>}
            {tooltip && (
              <span style={{ display: 'inline-flex' }}>
                <TooltipWithClickAway
                  tooltipText={tooltip.text}
                  tooltipKey={`${tooltip.key}-label`}
                  usePortal
                />
              </span>
            )}
          </span>
        </InputLabel>
        <Select
          id={name}
          name={name}
          className="select"
          labelId={`${name}Label`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          variant="outlined"
          displayEmpty
          IconComponent={CustomDropdownIcon}
          renderValue={(selected) => {
            if (!selected) {
              return <em>{placeholder}</em>;
            }
            const option = options.find(opt => opt.value === selected);
            const displayLabel = option ? option.label : selected;
            return (
              <span title={displayLabel as string} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {displayLabel}
              </span>
            );
          }}
          inputProps={{
            style: { ...FORM_STYLES.INPUT, fontSize: '13px' },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              title={option.label}
              style={{ fontSize: '13px' }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default FormikSelect;